<accordion [isAnimated]="true">
  <form class="form-horizontal" [formGroup]="personInformationForm">
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-user'></i> Datos Personales
      </span>

      <div class="row">
        <div class="form-group col-md-6">
          <label class="col-form-label"><b>Nombre</b>
            <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="names"></span>
          </label>
          <input type="text" class="form-control" formControlName="names">
        </div>
        <div class="form-group col-md-6">
          <label class="col-form-label"><b>Apellido</b>
            <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="lastNames"></span>
          </label>
          <input type="text" class="form-control" formControlName="lastNames">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-8">
          <label class="col-form-label"><b>Identificación</b>
            <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="fiscalId"></span>
          </label>
          <input type="text" class="form-control" formControlName="fiscalId">
        </div>
        <div class="form-group col-md-4">
          <label class="col-form-label"><b>Tipo de Identificación</b>
            <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="fiscalIdName"></span>
          </label>
          <input type="text" class="form-control" formControlName="fiscalIdName">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nacionalidad</b>
          <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="nationality"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="nationality" [items]="nationalities" bindLabel="name" bindValue="code"
            formControlName="nationality">
          </ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Sexo</b>
          <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="sex"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="sex">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-8">
          <label class="col-form-label"><b>Fecha de Nacimiento</b>
            <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="birthDate"></span>
          </label>
          <input bsDatepicker class="form-control" formControlName="birthDate"
            [bsConfig]="{ isAnimated: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }"
            [ngClass]="personInformationForm.controls.birthDate.errors ? 'is-invalid' : 'is-valid'" [readOnly]="readonly">
          <!-- [ngClass]="companyInformationForm.controls.operationDate.errors ? 'is-invalid' : 'is-valid'" -->
        </div>
        <div class="form-group col-md-4">
          <label class="col-form-label"><b>Edad</b>
            <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="age"></span>
          </label>
          <input type="text" class="form-control" formControlName="age">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Estado Civil</b>
          <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="civilStatus"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select [items]="civilStatuses" bindLabel="value" bindValue="value" formControlName="civilStatus" [readonly]="readonly">
          </ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Número de Dependientes</b>
          <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="dependentsAmount"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="number" class="form-control" formControlName="dependentsAmount"
            [ngClass]="personInformationForm.controls.dependentsAmount.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Correo Electrónico</b>
          <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="email"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="email"
            [ngClass]="personInformationForm.controls.email.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        </div>
      </div>

    </accordion-group>
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-list'></i> Información Complementaria
      </span>

      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4">
          <b>Vehículo</b>
          <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="vehicle"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="vehicle" [readonly]="readonly">
            <ng-option [value]="true">Si</ng-option>
            <ng-option [value]="false">No</ng-option>
          </ng-select>
        </div>

      </div>
      <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Profesión u oficio</b>
          <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="ocupation"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select [items]="ocupations" bindLabel="value" bindValue="key" formControlName="ocupation" [readonly]="readonly"></ng-select>
        </div>
      </div>
      <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Grado Academico</b>
          <span appRequiredAsterisk [formGroup]="personInformationForm" controlName="academicTitle" ></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select [items]="academicTitles" bindLabel="value" bindValue="key" formControlName="academicTitle" [readonly]="readonly">
          </ng-select>
        </div>
      </div>
    </accordion-group>
  </form>
</accordion>
